"use strict";
/**
 * GUPIS Swagger API docs: https://gupis-sandbox.apps.mega.cariad.cloud/swagger-ui/index.html
 */
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=types.js.map